module.exports = __webpack_public_path__ + "assets/icons/icon_signal2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/icon_signal2.svg
// module id = Nl++
// module chunks = 1